import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/SwipeLimitModal.css';

export default function SwipeLimitModal({ message, onClose, onUpgrade }) {
  return (
    <AnimatePresence>
      <motion.div
        className="limit-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="limit-modal"
          initial={{ scale: 0.5 }}
          animate={{ scale: 1 }}
          exit={{ scale: 0.5 }}
          transition={{ type: 'spring', duration: 0.4 }}
          onClick={(e) => e.stopPropagation()}
        >
          <h1>Upgrade Required</h1>
          <p>{message}</p>
          <div className="limit-actions">
            <button onClick={onClose}>Not now</button>
            <button onClick={onUpgrade} className="primary">
              See plans
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}